import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptyStatePayments = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 537.03 500",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".c{opacity:.05;}.d{fill:#ebf3ff;}.e{fill:#fafcff;}.f,.g{fill:#9ec5ff;}.h{fill:#b5c5ea;}.i{fill:#dcebfe;}.g{font-family:CheltenhamPro-Bold, ITC Cheltenham Pro;font-size:28.78px;letter-spacing:.1em;}" }) }),
		/* @__PURE__ */ _jsx("g", {
			id: "a",
			children: /* @__PURE__ */ _jsx("circle", {
				className: "e",
				cx: 269.96,
				cy: 250,
				r: 246.8
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			id: "b",
			children: [
				/* @__PURE__ */ _jsxs("g", { children: [
					/* @__PURE__ */ _jsxs("g", {
						className: "c",
						children: [/* @__PURE__ */ _jsx("path", { d: "M372.59,379.5c0,86.68-49.16,81.56-109.81,81.56s-109.81,5.11-109.81-81.56,49.16-156.94,109.81-156.94,109.81,70.26,109.81,156.94Z" }), /* @__PURE__ */ _jsx("path", { d: "M325.2,139.85l-.89,7.08-14.15,61.16-3.37,26.74h-88l-3.37-26.74-13.21-53.74-.96-7.6c1.02,.8,2.07,1.2,3.59,1.2,2.56,0,3.77-1.16,5.84-3.38,2.16-2.32,5.13-5.5,10.72-5.5s8.54,3.18,10.7,5.5c2.07,2.21,3.27,3.38,5.85,3.38s3.78-1.16,5.85-3.38c2.16-2.32,5.13-5.5,10.7-5.5s8.56,3.18,10.72,5.5c2.07,2.21,3.27,3.38,5.85,3.38s3.77-1.16,5.84-3.38c2.16-2.32,5.13-5.5,10.72-5.5s8.54,3.18,10.72,5.5c2.07,2.21,3.26,3.38,5.84,3.38s3.78-1.16,5.85-3.38c2.16-2.32,5.13-5.5,10.72-5.5,1.71,0,3.18,.3,4.45,.78Z" })]
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "d",
						d: "M365.89,371.73c0,86.68-49.16,81.56-109.81,81.56s-109.81,5.11-109.81-81.56,49.16-156.94,109.81-156.94,109.81,70.26,109.81,156.94Z"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "d",
						d: "M318.5,132.09l-.89,7.08-14.15,61.16-3.37,26.74h-88l-3.37-26.74-13.21-53.74-.96-7.6c1.02,.8,2.07,1.2,3.59,1.2,2.56,0,3.77-1.16,5.84-3.38,2.16-2.32,5.13-5.5,10.72-5.5s8.54,3.18,10.7,5.5c2.07,2.21,3.27,3.38,5.85,3.38s3.78-1.16,5.85-3.38c2.16-2.32,5.13-5.5,10.7-5.5s8.56,3.18,10.72,5.5c2.07,2.21,3.27,3.38,5.85,3.38s3.77-1.16,5.84-3.38c2.16-2.32,5.13-5.5,10.72-5.5s8.54,3.18,10.72,5.5c2.07,2.21,3.26,3.38,5.84,3.38s3.78-1.16,5.85-3.38c2.16-2.32,5.13-5.5,10.72-5.5,1.71,0,3.18,.3,4.45,.78Z"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "h",
						d: "M318.5,132.09l-.89,7.08c-1.01-.8-2.04-1.2-3.56-1.2-2.58,0-3.78,1.16-5.85,3.39-2.16,2.32-5.13,5.49-10.72,5.49s-8.54-3.17-10.7-5.49c-2.08-2.23-3.27-3.39-5.85-3.39s-3.78,1.16-5.85,3.39c-2.16,2.32-5.13,5.49-10.7,5.49s-8.56-3.17-10.72-5.49c-2.07-2.23-3.27-3.39-5.85-3.39s-3.77,1.16-5.84,3.39c-2.17,2.32-5.13,5.49-10.72,5.49s-8.56-3.17-10.72-5.49c-2.07-2.23-3.26-3.39-5.84-3.39s-3.78,1.16-5.85,3.39c-2.16,2.32-5.13,5.49-10.7,5.49-.94,0-1.82-.09-2.63-.26l-.96-7.6c1.02,.8,2.07,1.2,3.59,1.2,2.56,0,3.77-1.16,5.84-3.38,2.16-2.32,5.13-5.5,10.72-5.5s8.54,3.18,10.7,5.5c2.07,2.21,3.27,3.38,5.85,3.38s3.78-1.16,5.85-3.38c2.16-2.32,5.13-5.5,10.7-5.5s8.56,3.18,10.72,5.5c2.07,2.21,3.27,3.38,5.85,3.38s3.77-1.16,5.84-3.38c2.16-2.32,5.13-5.5,10.72-5.5s8.54,3.18,10.72,5.5c2.07,2.21,3.26,3.38,5.84,3.38s3.78-1.16,5.85-3.38c2.16-2.32,5.13-5.5,10.72-5.5,1.71,0,3.18,.3,4.45,.78Z"
					}),
					/* @__PURE__ */ _jsx("polygon", {
						className: "h",
						points: "303.46 200.32 300.09 227.07 212.09 227.07 208.72 200.32 303.46 200.32"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "f",
						d: "M253.78,305.32v-9.24h4.53v9.24c7.79,0,16.39,3.89,16.39,11.5,0,4.17-2.99,6.7-6.8,6.7-2.99,0-5.89-2.63-5.89-5.71s2.17-3.53,2.17-5.34c0-2.26-3.26-2.81-5.43-2.81-5.07,0-11.87,1.63-11.87,8.15,0,5.62,5.62,7.34,12.05,9.42,9.15,2.99,18.3,6.61,18.3,19.84,0,10.23-9.15,17.57-18.93,18.84v10.87h-4.53v-10.51c-9.06-.27-18.84-5.43-18.84-15.12,0-4.35,2.44-7.52,6.7-7.52,3.8,0,6.7,2.99,6.7,6.7,0,4.44-4.17,3.99-4.17,6.43,0,3.35,7.16,4.8,9.97,4.8,5.43,0,13.13-2.81,13.13-9.69s-6.43-9.06-13.31-11.41c-8.61-2.99-17.03-6.43-17.03-18.48,0-8.69,8.06-15.67,16.85-16.66Z"
					})
				] }),
				/* @__PURE__ */ _jsxs("g", { children: [
					/* @__PURE__ */ _jsx("path", {
						className: "i",
						d: "M173.82,214.79H18.86v86.99H106.95l10.84,20.7c.48,.92,1.87,.89,2.32-.05l9.8-20.65h43.9v-86.99Z"
					}),
					/* @__PURE__ */ _jsx("text", {
						className: "g",
						transform: "translate(43.38 276.16)",
						children: /* @__PURE__ */ _jsx("tspan", {
							x: 0,
							y: 0,
							children: "$58.74"
						})
					}),
					/* @__PURE__ */ _jsx("rect", {
						className: "f",
						x: 44.49,
						y: 235.77,
						width: 103.7,
						height: 4.53,
						rx: 2.27,
						ry: 2.27
					})
				] }),
				/* @__PURE__ */ _jsxs("g", { children: [
					/* @__PURE__ */ _jsx("rect", {
						className: "i",
						x: 379.07,
						y: 255.1,
						width: 157.4,
						height: 102.7,
						rx: 9.95,
						ry: 9.95
					}),
					/* @__PURE__ */ _jsx("rect", {
						className: "f",
						x: 379.07,
						y: 276.31,
						width: 157.95,
						height: 17.52
					}),
					/* @__PURE__ */ _jsxs("g", { children: [
						/* @__PURE__ */ _jsx("rect", {
							className: "f",
							x: 335.45,
							y: 329.17,
							width: 157.4,
							height: 102.7,
							rx: 9.95,
							ry: 9.95
						}),
						/* @__PURE__ */ _jsx("rect", {
							className: "i",
							x: 335.45,
							y: 350.38,
							width: 157.95,
							height: 17.52
						}),
						/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("rect", {
							className: "i",
							x: 350.45,
							y: 403.87,
							width: 102.2,
							height: 4.47,
							rx: 2.23,
							ry: 2.23
						}), /* @__PURE__ */ _jsx("rect", {
							className: "i",
							x: 350.45,
							y: 383.87,
							width: 52.2,
							height: 4.47,
							rx: 2.23,
							ry: 2.23
						})] })
					] })
				] })
			]
		})
	]
});
export default SvgEmptyStatePayments;
